const getMessageInfo = (message) => message;

export default getMessageInfo;
